export enum FileType {

  PURCHASE_TERM = 1,
  PURCHASE_TERM_NAME = "Ford Protect Termo de Contratacao.pdf",
  PURCHASE_TERM_DESCRIPTION = "TERMO DE CONTRATAÇÃO - GARANTIA ESTENDIDA REDUZIDA",
	
  LICENSE_TERM = 2,
  LICENSE_TERM_NAME = "Ford Protect Termo de Autorizacao de Cobranca.pdf",
  LICENSE_TERM_DESCRIPTION = "TERMO DE AUTORIZAÇÃO DE COBRANÇA DE PRÊMIO",
	
  TICKET = 3,
  TICKET_NAME= "Ford Protect Bilhete de Seguro.pdf",
	
  UPDATE_TICKET = 4,
  UPDATE_TICKET_NAME = "Ford Protect Bilhete de Seguro Atualizado.pdf",
	
  CANCELLATION_TICKET = 5,
  CANCELLATION_TICKET_NAME = "Cancelamento Bilhete AIG.pdf",
	
  CONTRACT_SUCCESS_CO = 6,
  CONTRACT_SUCCESS_CO_NAME = "Ford Protect Termo Contratacao - Colombia.pdf",
	
  CONTRACT_SUCCESS_CH = 7,
  CONTRACT_SUCCESS_CH_NAME= "Ford Protect Termo Adesao Plano Manutencao.pdf",
  
  CONTRACT_SUCCESS_CO_AND_CH_DESCRIPTION = "TÉRMINOS Y CONDICIONES DEL PLAN DE MANTENIMIENTO PREPAGO FORD PROTECT",
	
  PENDING_SIGNATURE_CO = 8,
  PENDING_SIGNATURE_CO_NAME= "Ford Protect Pendente de Assinatura - Colombia.pdf",
	
  PENDING_SIGNATURE_CH = 9,
  PENDING_SIGNATURE_CH_NAME= "Ford Protect Pendente de Assinatura - Chile.pdf",
	
  CONTRACT_SUCCESS_ARG = 10,
  CONTRACT_TERMS_NAME_ARG = `Términos y Condiciones Servicio Ford Protect.pdf`,
  CONTRACT_SUCCESS_ARG_DESCRIPTION_USED_VEHICLE = "TÉRMINOS Y CONDICIONES SERVICIO FORD PROTECT - VEHICULOS USADOS DENTRO DEL PERIODO DE GARANTIA",
  CONTRACT_SUCCESS_ARG_DESCRIPTION_ZERO_KM_VEHICLE = "TÉRMINOS Y CONDICIONES SERVICIO FORD PROTECT - VEHICULOS 0 KM",
  
  CONTRACT_SUCCESS_ADHESION_DEALER_MAINTENANCE = 11,
  CONTRACT_SUCCESS_ADHESION_DEALER_MAINTENANCE_NAME= "Ford Protect Termo de Manutenção Pré-Paga.pdf",
  CONTRACT_SUCCESS_ADHESION_DEALER_MAINTENANCE_DESCRIPTION= "TERMO DE ADESÃO AO PLANO DE MANUTENÇÃO PRÉ-PAGA FORD PROTECT",
  
  CONTRACT_SUCCESS_DEALER_MAINTENANCE_ARGENTINA = 13,
  CONTRACT_SUCCESS_DEALER_MAINTENANCE_ARGENTINA_NAME = "Plan de Mantenimiento Prepago Ford Protect.pdf",
  CONTRACT_SUCCESS_DEALER_MAINTENANCE_ARGENTINA_DESCRIPTION = "TÉRMINOS Y CONDICIONES DE PLAN DE MANTENIMIENTO PREPAGO FORD PROTECT",
  
  INVALID = 99,
  INVALID_NAME = "Tipo Invalido de Arquivo",
  
  CONTRACT_TERMS_NAME = `Termos do Contrato.pdf`,
	
}